import { useState } from "react";
import { VStack, HStack, Heading, Text, Input, Button } from "@chakra-ui/react";
import { axiosInstanceWithoutToken } from "../Axios";
import { Link, useNavigate } from "react-router-dom";

const SignUp = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [securityKey, setSecurityKey] = useState("");
  const navigate = useNavigate();

  const handleLogIn = async () => {
    try {
      if (password !== confirmPassword) {
        alert("Passwords do not match");
        return;
      }
      if (securityKey !== process.env.REACT_APP_SECURITY_KEY) {
        alert("Invalid Security Key");
        return;
      }
      const res = await axiosInstanceWithoutToken.post("admin/signup", {
        email: email,
        password: password,
      });
      navigate("/login");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <HStack
      h="100vh"
      w="100vw"
      flexDir={["column", "column", "row"]} // Stack vertically on smaller screens
    >
      <VStack
        h={["40%", "40%", "full"]}
        w={["full", "50%", "50%"]}
        justifyContent={"center"}
        pos={"relative"}
      >
        <VStack
          _after={{
            content: '""',
            bg: "rgba(255, 22, 22, 0.5)",
            opacity: 0.5,
            pos: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
          bgRepeat={"no-repeat"}
          bgPos={"center"}
          bgSize={"cover"}
          bgImage={"/images/logIn-banner.png"}
          w="full"
          h="full"
        ></VStack>
        <VStack position={"absolute"} alignItems={"start"} px={4}>
          <Heading
            fontFamily={"Inter"}
            fontWeight={"600"}
            fontSize={["32px", "40px", "48px"]} // Adjust heading size for different screen sizes
            color={"#FFF"}
          >
            Sign Up!
          </Heading>
          <Text
            fontFamily={"Inter"}
            fontWeight={"400"}
            fontSize={["sm", "tablet", "lg"]}
            color={"#FFF"}
          >
            Create a free account and get full access to all features!
          </Text>
        </VStack>
      </VStack>
      <VStack
        justifyContent={"center"}
        w={["full", "full", "50%"]}
        p={[4, 8, 12]} // Adjust padding based on screen sizes
      >
        <VStack alignItems={"start"} w="full" maxW="400px">
          <Heading
            fontFamily={"Inter"}
            fontWeight={"600"}
            fontSize={["24px", "28px", "32px"]} // Responsive font sizes
          >
            Sign Up!
          </Heading>
          <VStack mt={4} w="full">
            <Input
              borderRadius={"10px"}
              placeholder="Email ID"
              type="email"
              onChange={(e) => setEmail(e.target.value)}
              size={["sm", "md"]} // Adjust input size based on screen size
            />
            <Input
              borderRadius={"10px"}
              placeholder="Password"
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              size={["sm", "md"]}
            />
            <Input
              borderRadius={"10px"}
              placeholder="Confirm Password"
              type="password"
              onChange={(e) => setConfirmPassword(e.target.value)}
              size={["sm", "md"]}
            />
            <Input
              borderRadius={"10px"}
              placeholder="Security Key"
              type="password"
              onChange={(e) => setSecurityKey(e.target.value)}
              size={["sm", "md"]}
            />
          </VStack>
          <Button
            borderRadius={"10px"}
            w="full"
            onClick={handleLogIn}
            color={"#FFF"}
            bg={"scarlet"}
            mt={2}
            size={["sm", "md"]} // Adjust button size for responsiveness
          >
            Sign Up
          </Button>
        </VStack>
        <HStack mt={4}>
          <Text fontSize={["sm", "md"]}>Already have an account?</Text>
          <Link to={"/login"}>
            <Text
              textDecor={"underline"}
              color={"dodgerBlue"}
              fontSize={["sm", "md"]}
            >
              Log In
            </Text>
          </Link>
        </HStack>
      </VStack>
    </HStack>
  );
};

export default SignUp;
